import { Check } from "lucide-react";

import {
  DataTable,
  NARROW_ONLY,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "@/components/data-table";
import { roleLabel, ROLES } from "@/lib/roles";
import { cn } from "@/lib/utils";

import { ROLE_ACCESS_IDS, useDocsContent } from "./content";
import { DocSubheading } from "./doc-parts";
import { rolesWithAccess } from "./role-access";

/**
 * Who sees what on the dashboard: a heading, a line on the roles, and a table
 * with what each row gives down the side and a column per role, named as the
 * Mensen tab names it, with a check mark where the role has the row. In the
 * table's phone layout the role columns leave and each row lists its roles
 * under its text instead, so the table never scrolls sideways. A note on the
 * Admins team ends it.
 */
export function RoleTable() {
  const { roles: text } = useDocsContent();
  return (
    <>
      <DocSubheading>{text.heading}</DocSubheading>
      <p>{text.intro}</p>
      <DataTable label={text.heading}>
        <TableHead>
          <TableHeadCell>{text.access}</TableHeadCell>
          {ROLES.map((role) => (
            <TableHeadCell key={role} align="center" narrow="hide">
              {roleLabel(role)}
            </TableHeadCell>
          ))}
        </TableHead>
        <tbody>
          {ROLE_ACCESS_IDS.map((row) => {
            const withAccess = rolesWithAccess(row);
            return (
              <TableRow key={row}>
                <TableCell>
                  <p className="text-foreground">{text.rows[row]}</p>
                  <p className={cn("text-muted text-xs", NARROW_ONLY)}>
                    {withAccess.map(roleLabel).join(", ")}
                  </p>
                </TableCell>
                {ROLES.map((role) => (
                  <TableCell key={role} align="center" narrow="hide">
                    {withAccess.includes(role) ? (
                      <>
                        <Check aria-hidden="true" className="text-primary mx-auto size-4" />
                        <span className="sr-only">{text.yes}</span>
                      </>
                    ) : (
                      <span className="sr-only">{text.no}</span>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </tbody>
      </DataTable>
      <p className="text-muted">{text.note}</p>
    </>
  );
}
